/**
 * Icon mapping for Material Symbols via @iconify/react
 * Usage: <Icon icon={ICONS.OVERVIEW} />
 */
export const ICONS = {
  // Navigation
  OVERVIEW: 'material-symbols:dashboard',
  I18N: 'material-symbols:translate',
  TRANSLATIONS: 'material-symbols:list-alt',
  WORKFLOW: 'material-symbols:approval',
  PRE_REVIEW: 'material-symbols:rate-review',
  REVIEW: 'material-symbols:group',
  CORRECTIONS: 'material-symbols:edit-note',
  CHANGES: 'material-symbols:swap-horiz',
  TOOLS: 'material-symbols:build',
  DUPLICATES: 'material-symbols:content-copy',
  BUG_REPORT: 'material-symbols:bug-report',
  ANALYTICS: 'material-symbols:analytics',
  ENDPOINTS: 'material-symbols:api',
  ERROR_CATALOG: 'material-symbols:report-outline',
  MCP: 'material-symbols:hub-outline',
  ADD: 'material-symbols:add',
  FIGMA: 'ph:figma-logo-duotone',
  SETTINGS: 'material-symbols:settings-outline',


  // Help section
  HELP: 'material-symbols:help-outline',
  GET_STARTED: 'material-symbols:flag',
  FAQ: 'material-symbols:quiz',
  TUTORIALS: 'material-symbols:school',
  SUPPORT: 'material-symbols:support-agent',
  DOCUMENTATION: 'material-symbols:article',
  LIVE_CHAT: 'material-symbols:chat',
  CONTACT_US: 'material-symbols:mail',

  // User actions
  MY_TICKETS: 'material-symbols:confirmation-number',
  MY_ACCOUNT: 'material-symbols:account-circle',
  SIGN_OUT: 'material-symbols:logout',
  KEY: 'material-symbols:key',
  DELETE: 'material-symbols:delete-outline',

  // Notifications
  NOTIFICATION_WORKFLOWS: 'material-symbols:mark-email-unread-outline',
  NOTIFICATIONS: 'material-symbols:notifications-outline',
  NOTIFICATIONS_ACTIVE: 'material-symbols:notifications-active',
  MARK_READ: 'material-symbols:done-all',

  // AppBar actions
  SEARCH: 'material-symbols:search',
  MENU: 'material-symbols:menu',

  // Sidebar controls
  COLLAPSE: 'material-symbols:chevron-left',
  EXPAND: 'material-symbols:chevron-right',

  // Navigation icons
  DASHBOARD: 'material-symbols:dashboard',

  // Backlog section
  REPORT: 'material-symbols:insert-chart',
  CALENDAR: 'material-symbols:calendar-month',
  EXPAND_MORE: 'material-symbols:expand-more',
  EXPAND_LESS: 'material-symbols:expand-less',

  // Tenant Management
  TENANTS: 'material-symbols:domain',
  SYNC: 'material-symbols:sync',
  AZURE_DEVOPS: 'mdi:microsoft-azure-devops',
} as const;

export type IconName = (typeof ICONS)[keyof typeof ICONS];
